import React from "react";
import { SmsCampaignStatus } from "@tiny/api";
import { Chip } from "../components";
import { ChipColor } from "@tiny/components/src/Chip/Chip.types";

interface SmsCampaignStatusProps {
  status?: SmsCampaignStatus;
}

function getChipColor(status?: SmsCampaignStatus): ChipColor {
  switch (status) {
    case "SCHEDULED":
      return "yellow";
    case "QUEUED":
    case "LAUNCHED":
      return "blue";
    case "COMPLETED":
      return "primary";
    case "PAUSED":
    case "PAUSED_NO_CREDITS":
      return "red";
    case "FAILED":
      return "black";
    case "CANCELLED":
    case "DRAFT":
    default:
      return "grey";
  }
}

function SmsCampaignStatusText(
  props: SmsCampaignStatusProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { status } = props;

  return (
    <Chip ref={ref} label={status ?? "DRAFT"} color={getChipColor(status)} />
  );
}

export default React.forwardRef(SmsCampaignStatusText);
